export default __webpack_public_path__ + "images/4e738d00015457056ddca3bbd591c17c-curnow.png";